<div class="users-container">
  @for(user of onlineUsers; track user._id){
    <div class="user-container online">
      <div class="flex items-center justify-between w-full">
        <div class="flex flex-col min-w-0">
          <span class="text-black text-lg acc-name font-semibold">{{ user.name }}</span>
          @if(user._slackStatus?.endAt){
            <small class="text-xs text-gray-500">Until {{ user._slackStatus.endAt | date:'MM/dd/yy hh:mm a' }}</small>
          }
        </div>
        @if(user._slackStatus && (user._slackStatus.emoji || user._slackStatus.text)){
          <span class="text-gray-500 status text-base flex items-center gap-1 min-w-0" [title]="user._slackStatus.text">
            @if(user._slackStatus.emoji){<span class="slack-emoji">{{ user._slackStatus.emoji }}</span>}
            @if(user._slackStatus.text){<span style="text-wrap: wrap;" class="slack-text truncate">{{ user._slackStatus.text }}</span>}
          </span>
        } @else {
          <span class="text-green-400 status text-base">Online</span>
        }
      </div>
    </div>
  }
  @for(user of afkUsers; track user._id){
    <div class="user-container afk">
      <div class="flex items-center justify-between w-full">
        <div class="flex flex-col min-w-0">
          <span class="text-black text-lg acc-name font-semibold">{{ user.name }}</span>
          <small *ngIf='user._lastActive' class="text-xs text-black">Last active: {{ user._lastActive | date:'hh:mm aaa' }}</small>
          @if(user._slackStatus?.endAt){
            <small class="text-xs text-gray-500">Until {{ user._slackStatus.endAt | date:'MM/dd/yy hh:mm a' }}</small>
          }
        </div>
        @if(user._slackStatus && (user._slackStatus.emoji || user._slackStatus.text)){
          <span class="text-yellow-400 status text-base flex items-center gap-1 min-w-0" [title]="user._slackStatus.text">
            @if(user._slackStatus.emoji){<span class="slack-emoji">{{ user._slackStatus.emoji }}</span>}
            @if(user._slackStatus.text){<span style="text-wrap: wrap;" class="slack-text truncate">{{ user._slackStatus.text }}</span>}
          </span>
        } @else {
          <span class="text-yellow-400 status text-base">Away</span>
        }
      </div>

    </div>
  }
  @for(user of offlineUsers; track user._id){
    <div class="user-container offline">
      <div  class="flex items-center justify-between w-full">
        <div class="flex flex-col min-w-0">
          <span class="text-black text-lg acc-name font-semibold">{{ user.name }}</span>
          @if(user._slackStatus?.endAt){
            <small class="text-xs text-gray-500">Until {{ user._slackStatus.endAt | date:'MM/dd/yy hh:mm a' }}</small>
          }
        </div>
        @if(user._slackStatus && (user._slackStatus.emoji || user._slackStatus.text)){
          <span class="text-gray-500 status text-base flex items-center gap-1 min-w-0" [title]="user._slackStatus.text">
            @if(user._slackStatus.emoji){<span class="slack-emoji">{{ user._slackStatus.emoji }}</span>}
            @if(user._slackStatus.text){<span style="text-wrap: wrap;" class="slack-text truncate">{{ user._slackStatus.text }}</span>}
          </span>
        } @else {
          <span class="text-red-400 status text-base">Offline</span>
        }
      </div>
    </div>
  }
</div>
